import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Recipes/Update';

const { displayName } = config;

function RecipeUpdate(): React.JSX.Element {
  document.title = `${displayName}: Редактировать рецепт`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default RecipeUpdate;
